import { Link } from 'react-router-dom';
import clsx from 'clsx';
import image from './logo-bordier.png';

interface LogoBordierProps {
  className?: string;
}

export const LogoBordier = (props: LogoBordierProps) => (
  <Link to='/' className={clsx('h-[78px] mx-auto', props.className)}>
    <img className='h-full object-contain' src={image} />
  </Link>
);
